import { create } from "zustand";

interface ResourceState {
  // Available options
  topicsFilterOptions: string[];
  setTopicsFilterOptions: (newFilters: string[]) => void;

  typeFilterOptions: string[];
  setTypeFilterOptions: (newFilters: string[]) => void;

  // Active filters
  filters: {
    topic: string[];
    type: string[];
    searchQuery: string;
  };

  // Actions
  setFilter: (
    key: keyof ResourceState["filters"],
    value: string[] | string,
  ) => void;
  resetFilters: () => void;
  toggleFilterItem: (
    key: keyof ResourceState["filters"],
    value: string,
  ) => void;
  clearFilter: (key: keyof ResourceState["filters"]) => void;
}

const useFilterStore = create<ResourceState>((set) => ({
  // Available options
  topicsFilterOptions: [],
  setTopicsFilterOptions: (newFilters) =>
    set({ topicsFilterOptions: newFilters }),

  typeFilterOptions: [
    "Blogs",
    "eBooks",
    "Webinars and Videos",
    "White Papers",
    // "Research Publications",
  ],
  setTypeFilterOptions: (newFilters) => set({ typeFilterOptions: newFilters }),

  // Active filters
  filters: {
    topic: [],
    type: [],
    searchQuery: "",
  },

  // Actions
  // Set a specific filter
  setFilter: (key, value) =>
    set((state) => ({
      filters: { ...state.filters, [key]: value },
    })),

  // Reset all filters
  resetFilters: () =>
    set({
      filters: { topic: [], type: [], searchQuery: "" },
    }),

  // Toggle an item in an array filter (topic or type)
  toggleFilterItem: (key: keyof ResourceState["filters"], value: string) =>
    set((state) => {
      const currentValues = state.filters[key];

      // Check if the value is an array
      if (Array.isArray(currentValues)) {
        const updatedValues = currentValues.includes(value)
          ? currentValues.filter((item) => item !== value)
          : [...currentValues, value];
        return {
          filters: {
            ...state.filters,
            [key]: updatedValues,
          },
        };
      }

      return state;
    }),

  // Clear a specific filter (e.g., topic or type)
  clearFilter: (key) =>
    set((state) => ({
      filters: { ...state.filters, [key]: key === "searchQuery" ? "" : [] },
    })),
}));

export default useFilterStore;
